import { secureTranslation } from '@/i18n';
import validation from '@/slango-multiverse/helpers/validations';
export default {
  props: {
    modelValue: {},
    disabled: Boolean,
    required: Boolean,
    formatRequired: Boolean,
    multiple: Boolean,
    type: String,
    subtype: String,
    items: Array,
    placeholder: String,
    text: String,
    hintText: String,
    label: String,
    icon: String,
    image: String,
    related: Object,
    validation: Object,
    validationGroup: {},
    autovalidation: Boolean
  },
  emits: ['update:modelValue', 'update:validation', 'error', 'actionCallback', 'created', 'getValue'],
  data: function () {
    return {
      value: undefined,
      translate: secureTranslation,
      componentId: Math.floor(Math.random() * 9000) + 1000,
      validationStatus: undefined
    };
  },
  computed: {
    hasError() {
      if (!this.validationStatus) return;
      const {
        empty,
        valid
      } = this.validationStatus;
      return this.required && empty || this.formatRequired && !empty && !valid;
    }
  },
  watch: {
    modelValue: {
      handler() {
        this.value = this.modelValue;
      },
      deep: true
    },
    value: {
      handler() {
        this.$emit('update:modelValue', this.value);
        if (this.autovalidation) {
          this.validate();
        }
      },
      deep: true
    },
    validationStatus() {
      if (this.validationStatus.automaticErrorCheck) {
        this.validationStatus.hasError = this.hasError;
      }
      this.$emit('update:validation', this.validationStatus);
    },
    error: {
      handler() {
        this.$emit('error');
      },
      deep: true
    }
  },
  created() {
    this.value = this.modelValue;
    this.$emit('created', this);
    this.registerInput();
  },
  mounted() {
    if (this.autovalidation) {
      this.validate();
    }
  },
  unmounted() {
    this.unregisterInput();
  },
  methods: {
    registerInput: function () {
      let group;
      let excludeOfGeneralGroup;
      const config = {
        validate: this.validate,
        showError: msg => this.validationStatus = {
          hasError: true,
          msg
        }
      };
      if (this.validationGroup) {
        if (Array.isArray(this.validationGroup)) {
          group = this.validationGroup[0];
          excludeOfGeneralGroup = this.validationGroup[1];
        } else {
          group = this.validationGroup;
        }
        if (!this.$registeredInputs[group]) this.$registeredInputs[group] = {};
        this.$registeredInputs[group][this.componentId] = config;
      }
      if (!excludeOfGeneralGroup) this.$registeredInputs.all[this.componentId] = config;
    },
    unregisterInput: function () {
      const inputs = this.$registeredInputs;
      if (inputs[this.validationGroup]) delete inputs[this.validationGroup][this.componentId];
      delete inputs.all[this.componentId];
    },
    validate: function (automaticErrorCheck) {
      this.validationStatus = validation.check(this.value, this.subtype ?? this.type);
      this.validationStatus.automaticErrorCheck = automaticErrorCheck;
      return !this.hasError;
    }
  }
};